import ApiService, { HTTPMethod } from './api.core'
import { FirebaseService, FirebaseConfigKey } from '../services/FirebaseService'

class OperatorsApi {
  async addOperator(values) {
    let data = Object.assign({}, values, {
      identification_number: 311510085,
      license_endorsed_for_motorcycle:
        values.license_endorsed_for_motorcycle == 'yes',
      recent_accident: values.recent_accident == 'yes',
      own_home: values.own_home == 'yes',
      vehicle_ids: values.operates,
    })

    return ApiService.fetch('users/me/persons', HTTPMethod.POST, data)
  }

  async updateOperator(values) {
    let data = Object.assign({}, values, {
      identification_number: 311510085,
      license_endorsed_for_motorcycle:
        values.license_endorsed_for_motorcycle == 'yes',
      recent_accident: values.recent_accident == 'yes',
      own_home: values.own_home == 'yes',
      vehicle_ids: values.operates,
    })
    return ApiService.fetch(
      `users/me/persons/${values.id}`,
      HTTPMethod.PUT,
      data
    )
  }

  async deleteOperator(id) {
    return ApiService.fetch('users/me/persons', HTTPMethod.DELETE, {
      user_insured_person_id: id,
    })
  }
}

export default new OperatorsApi()
